import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/status'

const find = (queryParams = '', organization) => AxiosClient.get(
  `${resource}?${queryParams}`, { headers: { organization } }
)

export {
  find
}
